import React, { Component } from 'react';

import * as types from 'misc/types';
import { getText } from 'misc/helpers';

class AttachmentListItem extends Component {
    render = () => {
        return (
            <li>
                <img src={this.getIcon(this.props.type, this.props.contentType)} alt="" />
                <span>{this.getLabel(this.props)}</span>
                <button
                    className="button-white button-small button-hover-no-outline"
                    onClick={() => this.openContent(this.props.type, this.props.url)}
                >
                    {getText('ButtonOpen', 'Öppna')}
                </button>
            </li>
        );
    };

    getLabel(props) {
        if (props.type === 2) {
            return props.title;
        } else {
            return props.filename;
        }
    }

    getIcon(type, contentType) {
        if (type === types.PRESENTATION_TYPES.MOVIE) {
            return 'assets/images/inbox/attachments/ico_youtube.svg';
        } else {
            if (contentType.indexOf('pdf') >= 0) {
                return 'assets/images/inbox/attachments/ico_pdf.svg';
            } else if (contentType.indexOf('calendar') >= 0) {
                return 'assets/images/inbox/attachments/ico_calendar.svg';
            } else {
                return 'assets/images/inbox/attachments/ico_document.svg';
            }
        }
    }

    openContent() {
        const { id, type, url } = this.props;

        if (type === types.PRESENTATION_TYPES.MOVIE) {
            window.open(url);
        } else {
            window.open('#/document/' + id, '_blank');
        }
    }
}

export default AttachmentListItem;



// WEBPACK FOOTER //
// ./src/components/inbox/AttachmentListItem.js